import { BaseModel } from '../../_base/crud';
import { UserFile } from '../../models/userFiles.model';
import { Address } from './address.model';
import { SmallCampaignDto } from '../../models/smallCampaignDto.model';

export class User extends BaseModel {
    id: string;
    userName: string;
    firstName: string;
    lastName: string;
    documentType: string;
    documentNumber: string;
    birthDate: string;
    phoneNumber: string;
    cuil: string;
    sex: string;
    nationality: string;
    email: string;
    password: string;
    roles: any; // En la tabla de revendedoras se manda un string con todos los roles y en otros lados un string[]
    pic: string;
    address: Address;
    referer: string;
    leader: any;
    userStatus: any; // En algunos lados se manda el valor del enum y en otros el nombre del valor
    assignedLevelId: number;
    assignedCampaignId: number;
    assignedLevelName: string;
    newAssignedLevelId: number;
    resellerStatus: any; // En algunos lados se manda el valor del enum y en otros el nombre del valor
    entornoLogistico: boolean;
    condicionIVA: string;
    userFiles: UserFile[];
    isFounder: boolean;
    creationDate: string;
    creditType: string;
    leaderLevelId: any;
    leaderLevelName: any;
    routeId: any;
    codeRoute: number;
    sequence: any;
    campaignFirstOrderName: any;
    campaignFirstOrderId: number;
    campaignLastRestartName: any;
    campaignLastTerminationName: any;
    inactiveCampaigns: number;
    profileStatusType: any; // En algunos lados se manda el valor del enum y en otros el nombre del valor
    referrerId: string;
    referrerUserName: string;
    referrerFullName: string;
    referrerGift: string;
    geoLocatedZoneLevelId: number;
    orderStatus: number;

    firstApplicationUserLevel: SmallCampaignDto;
    haveOrder: boolean;

    clear(): void {
        this.id = undefined;
        this.userName = '';
        this.firstName = '';
        this.lastName = '';
        this.documentNumber = '';
        this.birthDate = '';
        this.phoneNumber = '';
        this.sex = '';
        this.nationality = '';
        this.email = '';
        this.password = '';
        this.roles = [];
        this.pic = './assets/media/users/default.jpg';
        this.address = new Address();
        this.address.clear();
    }
}
